import React from 'react';
import PropTypes from 'prop-types';
import oops from '@pcid/utils/oops';

import LoadingPage from '../loading-page';
import { withFeatureFlags } from '../config-context';

export class RestrictedRoute extends React.Component {
	componentDidMount() {
		if (!this.shouldAllow()) {
			return oops.notFound();
		}

		if (this.isUnderMaintenance()) {
			return oops.maintenance();
		}
		return false;
	}

	shouldAllow() {
		if (this.isFeatureLocked()) {
			return false;
		}
		return true;
	}

	/**
	 * If RP has maintenance flag turned on, then send them to maintenance page.
	 */
	isUnderMaintenance() {
		const { featureFlags: { maintenance } } = this.props;
		return maintenance;
	}

	/**
	 * Given the passed in `restrictedFeatures`, determine if any of those feature flags
	 * are currently false, which should block the route.
	 */
	isFeatureLocked() {
		const { featureFlags, restrictedFeatures } = this.props;
		return restrictedFeatures.some((name) => featureFlags[name] === false);
	}

	render() {
		const {
			featureFlags, // Destructured but not used so it's not passed down to component
			component: Component,
			...componentProps
		} = this.props;

		if (!this.shouldAllow() || this.isUnderMaintenance()) {
			return <LoadingPage />;
		}

		return <Component {...componentProps} />;
	}
}

RestrictedRoute.propTypes = {
	featureFlags: PropTypes.object.isRequired,
	component: PropTypes.func.isRequired,
	restrictedFeatures: PropTypes.array,
};

RestrictedRoute.defaultProps = {
	restrictedFeatures: [],
};

export default (Component, restrictedFeatures) => withFeatureFlags((props) => (
	<RestrictedRoute component={Component} restrictedFeatures={restrictedFeatures} {...props} />
));
